import { createContext, useContext } from 'react';
import type { AdminUiLabelKey } from '../constants/adminUiLabels';

export interface AdminUiLabelsContextValue {
  adminUiLabels: Partial<Record<AdminUiLabelKey, string>>;
}

const AdminUiLabelsContext = createContext<AdminUiLabelsContextValue>({
  adminUiLabels: {},
});

export const AdminUiLabelsProvider = AdminUiLabelsContext.Provider;

export function useAdminUiLabels(): AdminUiLabelsContextValue {
  return useContext(AdminUiLabelsContext);
}
